<template>
  <div class="edit-layout-actions">
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      v-b-tooltip.hover
      v-b-modal.layout-template-modal
      :title="$t('header.action.add-layout-template')"
      variant="primary"
      target="_blank"
      class="layout-action"
      :disabled="isSavingLayout"
    >
      <feather-icon icon="ClipboardIcon" />
      <h6 class="text-white mb-0 ml-50 mr-50">
        {{ $t('header.action.save-template') }}
      </h6>
    </b-button>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      v-b-tooltip.hover
      v-b-modal.get-template
      :title="$t('header.action.import-layout-template')"
      variant="primary"
      target="_blank"
      class="layout-action"
      :disabled="isSavingLayout"
    >
      <feather-icon icon="UploadIcon" />
      <h6 class="text-white mb-0 ml-50 mr-50">
        {{ $t('header.action.import-template') }}
      </h6>
    </b-button>
    <layout-template-create-modal />
    <layout-template-get-modal :alert="message" />
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive';
import ToastNotificationsMixin from '@core/mixins/toast-notifications/ToastNotificationsMixin';
import LayoutTemplateCreateModal from '@core/components/layouts/apps-layout/LayoutTemplateCreateModal.vue';
import LayoutTemplateGetModal from '@core/components/layouts/apps-layout/LayoutTemplateGetModal.vue';
//import { ENABLED_APPS_ACTIONS, ENABLED_APPS_MUTATIONS, ENABLED_APPS_GETTERS } from '@/store/enabled-apps/enabled-apps-store-constants';

export default {
  name: 'EditLayoutActions',
  directives: {
    Ripple,
  },
  components: {LayoutTemplateCreateModal, LayoutTemplateGetModal},
  mixins: [ToastNotificationsMixin],
  data() {
    return {
      isSavingLayout: false,
      message: this.$t('header.action.alert-layout-template')
    };
  },
  computed: {
    // hasLayoutTemplates() {
    //   return this.$store.getters.layoutTemplates?.unpaginated.length > 0;
    // },
  },
  methods: {
    //
  },
};
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-include'; // Bootstrap includes

.layout-action {
  padding: 0.5rem;
  margin-left: 0.5rem;
  display: flex;
  &:first-child {
    margin-left: 0;
  }
  @include media-breakpoint-up(md) {
    padding: 0.7rem;
  }
}

.edit-layout-actions {
  display: flex;
}

.buttons-pack {
  display: flex;
}
</style>
